import Vue from 'vue';

export class DevIndexPage extends Vue {
}

export default DevIndexPage;